import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.marquee__splide' ).length ) {
        $( '.marquee__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: false,
            gap: '52px',
            arrows: false,
            autoWidth: true,
            pagination: false,
            autoScroll: {
              // Whole-pixel movement prevents trailing/ghosting in mobile Safari.
              speed: 1,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'marquee', COMPONENT );
} )( app );
